// src/utils/auth.js
// Updated auth utilities - no more localStorage!
import axios from 'axios';
import { buildApiUrl } from './apiUrl';

export const getUserRole = async () => {
	try {
		const response = await axios.get(buildApiUrl('auth/check'), {
			withCredentials: true,
		});
		return response.data.user?.role || null;
	} catch (error) {
		return null;
	}
};

export const hasRole = async (requiredRoles) => {
	const userRole = await getUserRole();
	return requiredRoles.includes(userRole);
};

export const isLoggedIn = async () => {
	try {
		const response = await axios.get(buildApiUrl('auth/check'), {
			withCredentials: true,
		});
		return response.data.isAuthenticated === true;
	} catch (error) {
		return false;
	}
};

export const getUserId = async () => {
	try {
		const response = await axios.get(buildApiUrl('auth/check'), {
			withCredentials: true,
		});
		return response.data.user?.id || null;
	} catch (error) {
		return null;
	}
};
